module.exports = __webpack_public_path__ + "img/aeroland-digital-store-product-07-570x470.c67d4b0d.jpg";